const validateAnswer = function (errors, vm, showTip) {
  // 验证过滤掉nps题
  // if (this.scoreQuType !== '6') {
  const { value, answerConfig: { requireInd } } = this
  if (requireInd === '1' && !value && sessionStorage.getItem('descChangeStatus') === '1') {
    errors.push(vm.cvtLang('tipScoreNull', vm.surveyInfoLang.tipScoreNull))
  }
  // }
  return !errors.length
}

const validate = function (vm, showTip) {
  const errors = []
  return {
    result: validateAnswer.call(this, errors, vm, showTip),
    errors
  }
}

const answerValidate = {
  validateAnswer,
  validate
}

export default answerValidate



// WEBPACK FOOTER //
// ./src/components/editor/RateBox/answerValidate.js